module.exports = __webpack_public_path__ + "static/hero-image-7844abc3f9887addb65ab05d8a46b369.jpg";